import UsersRepository from "../repository/Users.repository";

export default class Users {
  static async getAll() {
    return new Promise((resolve, reject) => {
      UsersRepository.getAll()
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  static async findById(id) {
    return new Promise((resolve, reject) => {
      UsersRepository.findById(id)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  static async create(user) {
    return new Promise((resolve, reject) => {
      UsersRepository.create(user)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  static async update(user) {
    return new Promise((resolve, reject) => {
      UsersRepository.update(user)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  static async updatePassword(id, password) {
    return new Promise((resolve, reject) => {
      UsersRepository.updatePassword(id, password)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  static async delete(id) {
    return new Promise((resolve, reject) => {
      UsersRepository.delete(id)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }
}
